import { Injectable } from '@angular/core';
import { WorkOrderFilterRepresentation } from '../work-order-filter-representation';

@Injectable({ providedIn: 'root' })
export class WorkOrderFilterStateService {
  private filters = new Map<string, WorkOrderFilterRepresentation>();

    constructor() {
    console.log(
      'WorkOrderFilterStateService instance created',
      Math.random()
    );
    }

  /** Get existing filter or create it once */
  getFilter(key: string): WorkOrderFilterRepresentation {
    if (!this.filters.has(key)) {
      this.filters.set(key, new WorkOrderFilterRepresentation());
    }
    return this.filters.get(key)!;
  }

  /** Explicitly overwrite a filter */
  setFilter(key: string, filter: WorkOrderFilterRepresentation): void {
    this.filters.set(key, filter);
  }

  /** Remove one filter */
  clearFilter(key: string): void {
    this.filters.delete(key);
  }

  /** Reset all filters (optional) */
  clearAll(): void {
    this.filters.clear();
  }
}
